import React, { useState } from "react";
import Layout from "../Common/Layout";
import { useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Home = () => {
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    companyName: "",
    contactNo: "",
    address: "",
    product: "",
    quantity: "",
    quality: "",
    date: "",
    tentativeStorageDate: "",
  });

  // Handle input changes
  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  // Handle form submission

const handleSubmit = async (e) => {
  e.preventDefault();

  try {
    const token = sessionStorage.getItem("token");

    // ✅ MAP FIELDS CORRECTLY
    const payload = {
      company_name: formData.companyName,
      contact_number: formData.contactNo,
      address: formData.address,
      product: formData.product,
      quantity: formData.quantity,
      quality_grade: formData.quality,
      order_date: formData.date,
      storage_tentative_date: formData.tentativeStorageDate,
    };

    const response = await fetch(
      "https://irc.zentelex.com/api/master-client",
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      }
    );

    const data = await response.json();

    if (!response.ok) {
      throw new Error(data.message || "Failed to submit data");
    }

    toast.success("✅ Data submitted for Approval!", {
      position: "top-right",
      autoClose: 2000,
      theme: "colored",
    });

    setTimeout(() => {
      navigate("/gateway-entry");
    }, 2500);
  } catch (error) {
    toast.error(error.message || "Something went wrong!", {
      position: "top-right",
      autoClose: 3000,
      theme: "colored",
    });
  }
};


  return (
    <>
      <Layout>
        <div className="content-page">
          <div className="content">
            <div className="container-fluid">
              <div className="row">
                <div className="col-12">
                  <div className="page-title-box">
                    <div className="page-title-right">
                      <ol className="breadcrumb m-0">
                        <li className="breadcrumb-item">
                          <a href="javascript:void(0);">IRC Ltd</a>
                        </li>
                        <li className="breadcrumb-item">
                          <a href="javascript:void(0);">Dashboards</a>
                        </li>
                        <li className="breadcrumb-item active">Welcome!</li>
                      </ol>
                    </div>
                    <h4 className="page-title">Welcome!</h4>
                  </div>
                </div>
              </div>

              {/* ===================== FORM START ===================== */}
              <div className="row justify-content-center mt-4">
                <div className="col-xxl-6 col-lg-8 col-md-10">
                  <div className="card shadow-sm border-0 rounded-3">
                    <div className="card-body p-4">
                      <h4 className="card-title mb-4 text-center fw-semibold text-primary">
                        Order Processing
                      </h4>

                      <form onSubmit={handleSubmit}>
                        {/* Company Name */}
                        <div className="mb-3">
                          <label
                            htmlFor="companyName"
                            className="form-label fw-semibold"
                          >
                            Company Name
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="companyName"
                            placeholder="Enter company name"
                            value={formData.companyName}
                            onChange={handleChange}
                            required
                          />
                        </div>

                        {/* Contact Number */}
                        <div className="mb-3">
                          <label
                            htmlFor="contactNo"
                            className="form-label fw-semibold"
                          >
                            Contact Number
                          </label>
                          <input
                            type="text"
                            className="form-control"
                            id="contactNo"
                            placeholder="Enter contact number"
                            value={formData.contactNo}
                            onChange={handleChange}
                            required
                          />
                        </div>

                        {/* Address */}
                        <div className="mb-3">
                          <label
                            htmlFor="address"
                            className="form-label fw-semibold"
                          >
                            Address
                          </label>
                          <textarea
                            className="form-control"
                            id="address"
                            placeholder="Enter full address"
                            rows="2"
                            value={formData.address}
                            onChange={handleChange}
                            required
                          />
                        </div>

                        {/* Product & Quantity */}
                        <div className="row">
                          <div className="col-md-6 mb-3">
                            <label
                              htmlFor="product"
                              className="form-label fw-semibold"
                            >
                              Product
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="product"
                              placeholder="Product name"
                              value={formData.product}
                              onChange={handleChange}
                              required
                            />
                          </div>

                          <div className="col-md-6 mb-3">
                            <label
                              htmlFor="quantity"
                              className="form-label fw-semibold"
                            >
                              Quantity
                            </label>
                            <input
                              type="number"
                              className="form-control"
                              id="quantity"
                              placeholder="Enter quantity"
                              value={formData.quantity}
                              onChange={handleChange}
                              required
                            />
                          </div>
                        </div>

                        {/* Quality & Dates */}
                        <div className="row">
                          <div className="col-md-6 mb-3">
                            <label
                              htmlFor="quality"
                              className="form-label fw-semibold"
                            >
                              Quality Grade
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="quality"
                              placeholder="e.g., A+, B, etc."
                              value={formData.quality}
                              onChange={handleChange}
                              required
                            />
                          </div>

                          <div className="col-md-6 mb-3">
                            <label
                              htmlFor="date"
                              className="form-label fw-semibold"
                            >
                              Date
                            </label>
                            <input
                              type="date"
                              className="form-control"
                              id="date"
                              value={formData.date}
                              onChange={handleChange}
                              required
                            />
                          </div>
                        </div>

                        {/* Tentative Storage Date */}
                        <div className="mb-4">
                          <label
                            htmlFor="tentativeStorageDate"
                            className="form-label fw-semibold"
                          >
                            Tentative Date of Storage
                          </label>
                          <input
                            type="date"
                            className="form-control"
                            id="tentativeStorageDate"
                            value={formData.tentativeStorageDate}
                            onChange={handleChange}
                            required
                          />
                        </div>

                        {/* Submit Button */}
                        <div className="text-center">
                          <button
                            type="submit"
                            className="btn btn-primary px-5 py-2 fw-semibold"
                          >
                            Submit
                          </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
              {/* ===================== FORM END ===================== */}
            </div>
          </div>
        </div>

        {/* ✅ Toast container must be rendered once */}
        <ToastContainer />
      </Layout>
    </>
  );
};

export default Home;
